import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import clsx from 'clsx';
import * as styles from './HeaderSearch.module.scss';

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
      fill="#0032B4"
    />
  </svg>
);

const ClearIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6667 1.175L10.4917 0L5.83333 4.65833L1.175 0L0 1.175L4.65833 5.83333L0 10.4917L1.175 11.6667L5.83333 7.00833L10.4917 11.6667L11.6667 10.4917L7.00833 5.83333L11.6667 1.175Z"
      fill="#0032B4"
    />
  </svg>
);

export const HeaderSearch = ({ className }: { className?: string }) => {
  const [value, setValue] = useState<string>(() =>
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('q') || '' : '',
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const isSearchPage = window.location.pathname === '/search';
    const hasQuery = new URLSearchParams(window.location.search).get('q');
    if (isSearchPage && !hasQuery) {
      window.location.href = '/';
    }
  }, []);

  const onClear = () => {
    setValue('');
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`);
    }
  };

  return (
    <div className={clsx(styles.headerSearch, className)}>
      <span className={styles.headerSearch__icon}>
        <SearchIcon />
      </span>
      <input
        className={styles.headerSearch__input}
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Search Cochran"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        aria-label="Search"
      />
      <button
        type="button"
        className={styles.headerSearch__clear}
        onClick={onClear}
        aria-label="Clear search"
        style={{ visibility: value ? 'visible' : 'hidden' }}
      >
        <ClearIcon />
      </button>
    </div>
  );
};
